import { observer } from 'mobx-react-lite'
import { InboxCommonPayment } from 'pages/settings/ui/InboxCommonPayment/InboxCommonPayment'
import { useAssignNumberStepsContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/context/useAssignNumberStepsContext'

export const Payment = observer(() => {
  const {
    paymentStore,
    assignNumbers,
    shouldShowPaymentNumbersList,
    loading,
    addSalesmsgNumbersStore: { numbersStore },
  } = useAssignNumberStepsContext()
  const { multiSelectedValues: numbers } = numbersStore

  return (
    <InboxCommonPayment
      salesmsgNumbers={numbers}
      shouldShowPaymentNumbersList={shouldShowPaymentNumbersList}
      licensesRequired={numbers.length}
      stepLoading={loading}
      paymentStore={paymentStore}
      handleOnClick={() => assignNumbers()}
      buttonText={`Add number${numbers.length > 1 ? 's' : ''}`}
    />
  )
})
